import React from 'react';
import { analyticsDestinations, defaultService } from './privacyCenter.constants';

export default class PrivacyCenter extends React.Component {
    constructor(props) {
        super(props);
        const { memberLoggedIn, services, supportPageUrl } = props;
        this.state = {
            isOverlayOpen: false,
            memberLoggedIn,
            services,
            supportPageUrl,
        };

        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onConfirmationClose = this.onConfirmationClose.bind(this);
        this.onAcceptDelete = this.onAcceptDelete.bind(this);
        this.updateOptionalConsentStatus = this.updateOptionalConsentStatus.bind(this);
        this.onExternalLinkClick = this.onExternalLinkClick.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.memberLoggedIn !== state.memberLoggedIn) {
            return null;
        }
        const { memberLoggedIn, services, supportPageUrl } = props;
        return { memberLoggedIn, services, supportPageUrl };
    }

    componentDidMount() {
        this.props.getServicesLinksAndConsentsStatus(this.props.locale);
        this.props.loadServicesConfig();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.locale !== prevProps.locale) {
            this.props.getServicesLinksAndConsentsStatus(this.props.locale);
        }
    }

    // Account Deletion Code - START
    onDeleteClick(event) {
        event.preventDefault();
        this.setState({
            isOverlayOpen: true,
        });
        this.props.startDeleteAccount();
    }

    onConfirmationClose() {
        this.setState({
            isOverlayOpen: false,
        });
    }

    onAcceptDelete(password) {
        this.props.deleteAccount(this.props.member, password);
    }

    updateOptionalConsentStatus(nl, locale) {
        this.props.updateOptionalConsentStatus(nl, locale);
    }

    onExternalLinkClick(event, data) {
        event.preventDefault();
        if (data.page && data.destination) {
            this.props.trackAgreementClick(data);
        } else {
            this.props.trackExternalLink(data);
        }
        window.open(event.currentTarget.getAttribute('href'), '_blank');
    }

    getServiceDetailsByConfig(service) {
        const { servicesConfig } = this.props;
        const serviceUuid = service.serviceUuid;
        const logo =
            servicesConfig[service.serviceUuid] && servicesConfig[service.serviceUuid].logo;
        const myrClientId =
            servicesConfig[service.serviceUuid] && servicesConfig[service.serviceUuid].myrClientId;
        const name =
            servicesConfig[service.serviceUuid] && servicesConfig[service.serviceUuid].name;
        const description =
            servicesConfig[service.serviceUuid] &&
            servicesConfig[service.serviceUuid].labelKey.intro;
        const privacySettingsLink =
            servicesConfig[service.serviceUuid] &&
            servicesConfig[service.serviceUuid].privacySettingsLink;
        const deleteServiceLinkEnabled =
            servicesConfig[service.serviceUuid] &&
            servicesConfig[service.serviceUuid].deleteServiceLinkEnabled;
        const social =
            servicesConfig[service.serviceUuid] && servicesConfig[service.serviceUuid].social;
        const unlinkSocialEnabled =
            servicesConfig[service.serviceUuid] &&
            servicesConfig[service.serviceUuid].unlinkSocialEnabled;

        return {
            serviceUuid,
            logo,
            name,
            description,
            privacySettingsLink,
            myrClientId,
            deleteServiceLinkEnabled,
            social,
            unlinkSocialEnabled,
        };
    }

    getAnalyticsDestination(consentKey) {
        return analyticsDestinations[consentKey];
    }

    getServiceUuidByMyrClientId() {
        const { servicesConfig } = this.props;
        for (let serviceUuid in servicesConfig) {
            if (
                servicesConfig.hasOwnProperty(serviceUuid) &&
                servicesConfig[serviceUuid].hasOwnProperty('myrClientId') &&
                servicesConfig[serviceUuid].myrClientId === 'myr'
            ) {
                return serviceUuid;
            }
        }
    }
}
